import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div<{ $isOpen: boolean }>`
  ${({ theme, $isOpen }) => css`
    width: 100%;
    max-width: 410px;
    @media screen and (min-width: ${theme.breakpoint.lg.minWidth}) {
      width: ${$isOpen ? '100%' : 'auto'};
      position: ${$isOpen ? 'absolute' : 'unset'};
    }
  `}
`;
